import axios from 'axios';

import { API_BASE_URL } from '@/constants';

import { objectToFormData } from './helpers';

export function sendFeedback(personName, companyName, contact) {
  return axios.post(`${API_BASE_URL}/partner-info/feedback`, objectToFormData({
    person_name: personName,
    company_name: companyName,
    contact,
  }));
}
